import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AccountService } from "../services";
import useUserStore from "../../../store/user";

export const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("Preencha todos os campos.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Nova senha e confirmação não conferem.");
      return;
    }
    if (newPassword.length < 8) {
      toast.error("A nova senha deve ter pelo menos 8 caracteres.");
      return;
    }
    if (newPassword === currentPassword) {
      toast.error("A nova senha deve ser diferente da atual.");
      return;
    }
    setLoading(true);
    try {
      const ok = await AccountService.changePassword(
        currentPassword,
        newPassword,
        confirmPassword,
      );
      if (ok) {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        navigate(user?.userType === "CUSTOMER" ? "/home" : "/admin");
      }
    } finally {
      setLoading(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: "100%",
    padding: "12px 14px",
    border: "1px solid #d0d5dd",
    borderRadius: "8px",
    fontSize: "14px",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "48px 16px",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          maxWidth: "420px",
          background: "#fff",
          border: "1px solid #eaecf0",
          borderRadius: "12px",
          padding: "32px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: "20px", color: "#101828" }}>
            Trocar senha
          </h2>
          <p style={{ margin: "6px 0 0", fontSize: "14px", color: "#667085" }}>
            Atualize a senha da sua conta. Mínimo de 8 caracteres.
          </p>
        </div>

        <label style={{ fontSize: "13px", color: "#344054" }}>
          Senha atual
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            style={{ ...inputStyle, marginTop: "6px" }}
            autoComplete="current-password"
          />
        </label>

        <label style={{ fontSize: "13px", color: "#344054" }}>
          Nova senha
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{ ...inputStyle, marginTop: "6px" }}
            autoComplete="new-password"
          />
        </label>

        <label style={{ fontSize: "13px", color: "#344054" }}>
          Confirmar nova senha
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{ ...inputStyle, marginTop: "6px" }}
            autoComplete="new-password"
          />
        </label>

        <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
          <button
            type="button"
            onClick={() =>
              navigate(user?.userType === "CUSTOMER" ? "/home" : "/admin")
            }
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #d0d5dd",
              background: "#fff",
              color: "#344054",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={loading}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "8px",
              border: "none",
              background: loading ? "#9cb9f5" : "#1264C7",
              color: "#fff",
              cursor: loading ? "default" : "pointer",
              fontSize: "14px",
            }}
          >
            {loading ? "Salvando..." : "Salvar nova senha"}
          </button>
        </div>
      </form>
    </div>
  );
};
